import React from 'react';

import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import { Body, SectionHeader } from '@grnhse/seedling/lib/birch/typography';

type Props = {
  title: string;
  body: string;
};

const SimpleMessage = (props: Props) => {
  return (
    <Stack spacing={3}>
      <SectionHeader>{props.title}</SectionHeader>

      <Body>{props.body}</Body>
    </Stack>
  );
};

export default SimpleMessage;
